import { render } from "./SquareCTA.vue?vue&type=template&id=d0a747ee"
import script from "./SquareCTA.vue?vue&type=script&lang=js"
export * from "./SquareCTA.vue?vue&type=script&lang=js"

import "./SquareCTA.vue?vue&type=style&index=0&id=d0a747ee&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__